/* @flow */
import React from 'react';
import SettingsView from 'settings/components/SettingsView.jsx';
import RequireDesktop from 'components/mixins/RequireDesktop';
import RequireSetup from 'setup/utils/RequireSetup';
import RequireUser from 'components/mixins/RequireUser';
import chainOnEnter from 'components/mixins/chainOnEnter';

let previousLocation;

const getPreviousLocation = {
  statics: {
    onEnter: () => {
      previousLocation = window.prevLocation;
    },
  },
};

const SettingsViewRouteHandler = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    chainOnEnter([RequireSetup, RequireDesktop, RequireUser, getPreviousLocation]),
  ],

  goBack() {
    if (previousLocation) {
      this.context.router.push(previousLocation);
    } else {
      this.context.router.push('/classes');
    }
  },

  render() {
    return (
      <SettingsView goBack={this.goBack} >
        {this.props.children}
      </SettingsView>
    );
  },
});

export default SettingsViewRouteHandler;



// WEBPACK FOOTER //
// ./src/settings/routeHandlers/SettingsViewRouteHandler.jsx